export const FETCH_EXHIBFLOOR_INFO_REQUEST = 'FETCH_EXHIBFLOOR_INFO_REQUEST';
export const FETCH_EXHIBFLOOR_INFO_SUCCESS = 'FETCH_EXHIBFLOOR_INFO_SUCCESS';
export const FETCH_EXHIBFLOOR_INFO_FAILURE = 'FETCH_EXHIBFLOOR_INFO_FAILURE';

export const FETCH_COMPANY_INFO_REQUEST = 'FETCH_COMPANY_INFO_REQUEST';
export const FETCH_COMPANY_INFO_SUCCESS = 'FETCH_COMPANY_INFO_SUCCESS';
export const FETCH_COMPANY_INFO_FAILURE = 'FETCH_COMPANY_INFO_FAILURE';

export const FETCH_TAGS_REQUEST = 'FETCH_TAGS_REQUEST';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_FAILURE = 'FETCH_TAGS_FAILURE';

export const SET_FILTER_SELECTED_ITEMS = 'SET_FILTER_SELECTED_ITEMS';

export const FETCH_BOOTH_CONFIGURATION_REQUEST = 'FETCH_BOOTH_CONFIGURATION_REQUEST';
export const FETCH_BOOTH_CONFIGURATION_SUCCESS = 'FETCH_BOOTH_CONFIGURATION_SUCCESS';
export const FETCH_BOOTH_CONFIGURATION_FAILURE = 'FETCH_BOOTH_CONFIGURATION_FAILURE';

export const UPDATE_EXHIBITOR_HASH_MAP = 'UPDATE_EXHIBITOR_HASH_MAP';
export const HANDLE_BOOTH_LIST_LOADER = 'HANDLE_BOOTH_LIST_LOADER';
export const UPDATE_CUSTOM_THEME_STYLE = 'UPDATE_CUSTOM_THEME_STYLE';

export const UPDATE_IS_EMBED = 'UPDATE_IS_EMBED';

export const UPDATE_IS_DIRECTORY_EMBED = 'UPDATE_IS_DIRECTORY_EMBED';